module.exports = __webpack_public_path__ + "static/images/smartspot-performance-pt-BR.37976ab8a037c8d5c3c7bbad5992c855.png";